class AppConfig {

    getServerUrl() {
        // STOP EDITING THIS FILE..
        if(window.location.hostname == 'localhost'){
            return "https://international-staging.paymob.com";
            //return "https://accept.paymobsolutions.com"
        }
        return "https://" + window.location.hostname;
    }
    getSentryKey() {
        let domain = window.location.hostname;
        if (domain == "ksa.paymob.com") {
            // Saudi Arabia
            return "https://9d7f5aec52e644ab9aac55b6d974fe43@o1052249.ingest.sentry.io/4505498480410624"
        } else if (domain == "uae.paymob.com") {
            // United Emirates
            return "https://dab20489ecba43ec81165610a3fbe16f@o1052249.ingest.sentry.io/4505498474577920"
        } else if (domain == "pakistan.paymob.com") {
            // Pakistan
            return "https://1f3dc0eae1654dadac565152bd381c6d@o1052249.ingest.sentry.io/4505498477395968 "
        } else if (domain == "oman.paymob.com") {
            // Oman
            return "https://d65047b939654930b98c22dfbed48df3@o1052249.ingest.sentry.io/4505498483621888"
        } else if (domain == "accept.paymob.com")  {
            // Egypt
            return "https://8c8fa182b431469c8880df6d7150b401@o1052249.ingest.sentry.io/4505498486177792"
        }
    }
}

export let appConfig = new AppConfig();